import React from 'react'
import { CircularProgress } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';

interface IFinalStep4Props {
    isSubmittingFinal: boolean
    className?: string
}

export const FinalStep4 = ({
    isSubmittingFinal,
    className = '',
}: IFinalStep4Props) => {
    const { clientTheme } = useThemeStyling()
    
    return (
        <div className={`emp-finalStep4-root ${className}`}>
            {isSubmittingFinal ? (
                <div>
                    <CircularProgress color="secondary" size={100} />
                </div>
            ) : (
                <div>
                    <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="emp-finalStep4-checkCircleIcon"
                        style={{ color: clientTheme.caseBuilder.submittingColor }}
                    />
                </div>
            )}
            <div
                style={{ color: clientTheme.caseBuilder.submittingColor }}
                className="emp-finalStep4-header"
            >
                Success
            </div>
            <div className="emp-finalStep4-subHeader">
                Your case was submitted successfully
            </div>
        </div>
    )
}
